export function getErrorMessage(error: unknown) {
    try {
        if (error instanceof Error) {
            return `${error.name}: ${error.message}`;
        }
        if (typeof error === "object") {
            return JSON.stringify(error);
        }

        return String(error);
    } catch {
        return "Unknown error";
    }
}
